import { Flex, Text } from "styles/utility-components";

import Modal from "components/ui/modal/Modal";
import { SavedViewForm } from "components/views/SavedViewForm";

type SaveViewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  saveView: (view: {
    viewName: string;
    viewDescription: string;
    alertFrequency: "DAILY" | "WEEKLY" | "NEVER";
  }) => void;
  loading?: boolean;
};

export function SaveViewModal({ isOpen, onClose, saveView, loading }: SaveViewModalProps) {
  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <Flex column>
        <Text h1>Save search</Text>
        <Text>
          Quickly access your most commonly used filters at anytime by creating filtered searches.
        </Text>
        <SavedViewForm
          defaultValues={{
            viewName: "",
            viewDescription: "",
            alertFrequency: "DAILY",
          }}
          onSubmit={({ viewName, viewDescription, alertFrequency }) => {
            saveView({ viewName, viewDescription, alertFrequency: alertFrequency || "NEVER" });
          }}
          onCancel={() => {
            onClose();
          }}
          isLoading={loading}
        />
      </Flex>
    </Modal>
  );
}
